
import { useState, useEffect } from "react";
import { Field, Form, Formik, FormikErrors } from 'formik';
import * as Yup from "yup";
import { CircularProgress } from '@mui/material';
import { SCHEDULE_DURATION } from '../../../utiles/constants'
import FormErrorContainer from '../shared/FormErrorContainer';
import CustomTimePicker from '../../components/timePicker'
import CustomSelect from '../../components/customSelect'
import useUtils from '../../../utiles/useUtiles';
import { ToolsFormValidation } from '../../../utiles/formValidation'

interface ToolsFormErrorI {
    start_time: string,
    end_time: string,
    call_duration: {label: string, value: string},
}

const Tools: React.FC = () => {

    const [loading, setLoading] = useState<boolean>(false);
    const [settingsData, setSettingsData] = useState<any>({});
    const { axiosRequest, baseUrl, toastInstance, loadingScreen } = useUtils()
    const axios = axiosRequest();
    const toast = toastInstance();

    useEffect(() => {
        listSettings();
    }, [])

    const listSettings = async ( ) => {
        setLoading( true );
        const request = await axios.get( `${baseUrl()}/settings?group_name=ibv_bank_verification_support_call` );
        const { error, result, message } = request.data;
        setLoading( false );
        if ( error ) {
            toast.error( message );
        } else {
            const data = result['rows'].reduce(( a: any, c: any ) => {
                a[c['key_name']] = c['value']
                return a;
            }, {})
            setSettingsData( data );
        }
    }
    const handleSubmit = async ( values: any ) => {
        setLoading( true );
        const request = await axios.put( `${baseUrl()}/settings`, { ...values } );
        const { error, message } = request.data;
        setLoading( false );
        if ( error ) {
            toast.error( message );
        } else {
            toast.success( message );
        }
    }
    
    return ( 
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="main-container">
                        <div className="main-container-inner">
                            <div className="main-card revrex-data-table-card">
                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                    <h1 className='page-title-sm'>Tools</h1>
                                </div>
                                <div className='row mb-3'>
                                    <div className="col-md-12">
                                        <h5>Timezone: {settingsData['timezone']}</h5>
                                    </div>
                                </div>
                                <Formik
                                    initialValues={{
                                        start_time: settingsData && settingsData['start_time'] || '00:00',
                                        end_time: settingsData && settingsData['end_time'] || '00:00',
                                        call_duration: SCHEDULE_DURATION[0]
                                    } as any}
                                    enableReinitialize={true}
                                    validateOnChange={true}
                                    validateOnBlur={true}
                                    validationSchema={ToolsFormValidation}
                                    onSubmit={async ( values ) => {
                                        const params = {
                                            ...values,
                                            call_duration: values['call_duration']['value']
                                        }
                                        handleSubmit(params);
                                    }}>
                                        {( { errors }: {errors: FormikErrors<ToolsFormErrorI>} ) => (
                                            <Form>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="cardCustom p-3">
                                                            <div className="row mb-2">
                                                                <div className="col-md-4">
                                                                    <label htmlFor="start_time">Schedule Start Time<span className="text-danger">*</span></label>
                                                                    <Field 
                                                                    name="start_time" 
                                                                    component={CustomTimePicker} 
                                                                    clearIcon={null} 
                                                                    disableClock="false"
                                                                    className={'form-control'}
                                                                    format={'hh:mm a'}
                                                                    hourPlaceholder={'hh'}
                                                                    minutePlaceholder={'mm'}
                                                                    />
                                                                    <FormErrorContainer nameError={errors.start_time} />
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label htmlFor="end_time">Schedule End Time<span className="text-danger">*</span></label>
                                                                    <Field 
                                                                    name="end_time" 
                                                                    component={CustomTimePicker} 
                                                                    clearIcon={null} 
                                                                    disableClock="false"
                                                                    className={'form-control'}
                                                                    format={'hh:mm a'}
                                                                    hourPlaceholder={'hh'}
                                                                    minutePlaceholder={'mm'}
                                                                    />
                                                                    <FormErrorContainer nameError={errors.end_time} />
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <CustomSelect 
                                                                    isRequired={true}
                                                                    label="Call Duration" 
                                                                    name="call_duration" 
                                                                    options={SCHEDULE_DURATION} 
                                                                    />

                                                                    {/* <Field
                                                                        name="call_duration"
                                                                        render={({ field }) => (
                                                                            <Select 
                                                                                {...field}
                                                                                onChange={selectedOption => {
                                                                                    let event = { target: { name: 'call_duration', value: selectedOption } };
                                                                                    field.onChange( event );
                                                                                }} 
                                                                                options={SCHEDULE_DURATION}
                                                                            />
                                                                        )}
                                                                    />
                                                                    <FormErrorContainer nameError={errors.call_duration}  /> */}
                                                                </div>
                                                            </div>
                                                            <div className="row mb-2">
                                                                <button type="submit" className="btn btn-md revrex-primary-btn mt-3" 
                                                                disabled={loading}>
                                                                    <span>{ loading && ( <CircularProgress size={20} color={'success'} /> ) || 'Save' }</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Form>
                                        )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
 
export default Tools;